import { createFileRoute } from "@tanstack/react-router";
import { marketingHead } from "../marketing-content/head";

export const Route = createFileRoute("/_workspace/")({
  head: () => marketingHead("/homepage"),
});
